import axios from "axios";


const getPrediction = async (ramanData) => {
    const formData = new FormData();
    formData.append("file", ramanData);
    try {
        const response = await axios.post("/api/raman-beta-dev", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        const body = await response.data;
        // const response = await fetch("/raman-beta-dev", {
        //     method: "POST",
        //     headers: {
        //         "Content-Type": "multipart/form-data",
        //     },
        //     body: formData
        // });
        // const body = await response.json()
        return {
            ramanShift: body.raman_shifts_x_axis,
            rawSignal: body.raw,
            preprocessedSignal: body.baseline_corrected,
            firstSignificant: body.top_first_positive_segment,
            secondSignificant: body.top_second_positive_segment,
            prediction: body.label,
        };
    } catch (e) {
        console.log(e);
        return null;
    }
};

export { getPrediction };
